import { Videos } from '@/modules/videos/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Videos.Pages.VIDEOS]: all_roles,
  [Videos.Pages.VIDEO_DETAIL]: all_roles,
};

export default access_roles;
